// Make sure to prefix the mutation names with the module to avoid collisions
export const COMMUNICATION_SET_COMMUNICATIONS = 'communicationSetCommunications'

export const COMMUNICATION_OPEN_SEND_TO_GROUPS_MODAL = 'communicationOpenSendToGroupsModal'
export const COMMUNICATION_CLOSE_SEND_TO_GROUPS_MODAL = 'communicationCloseSendToGroupsModal'
export const COMMUNICATION_OPEN_SEND_TO_MEMBERS_MODAL = 'communicationOpenSendToMembersModal'
export const COMMUNICATION_CLOSE_SEND_TO_MEMBERS_MODAL = 'communicationCloseSendToMembersModal'
export const COMMUNICATION_OPEN_ARCHIVE_BLOG_ENTRY_MODAL = 'communicationOpenArchiveBlogEntryModal'
export const COMMUNICATION_CLOSE_ARCHIVE_BLOG_ENTRY_MODAL = 'communicationCloseArchiveBlogEntryModal'
export const COMMUNICATION_OPEN_RESTORE_ARCHIVED_COMMUNICATION_MODAL = 'communicationOpenRestoreArchivedCommunicationModal'
export const COMMUNICATION_CLOSE_RESTORE_ARCHIVED_COMMUNICATION_MODAL = 'communicationCloseRestoreArchivedCommunicationModal'
export const COMMUNICATION_OPEN_DELETE_BLOG_ENTRY_MODAL = 'communicationOpenDeleteBlogEntryModal'
export const COMMUNICATION_CLOSE_DELETE_BLOG_ENTRY_MODAL = 'communicationCloseDeleteBlogEntryModal'

export const COMMUNICATION_OPEN_ARCHIVE_EMAIL_MODAL = 'communicationOpenArchiveEmailModal'
export const COMMUNICATION_CLOSE_ARCHIVE_EMAIL_MODAL = 'communicationCloseArchiveEmailModal'
export const COMMUNICATION_OPEN_DELETE_EMAIL_MODAL = 'communicationOpenDeleteEmailModal'
export const COMMUNICATION_CLOSE_DELETE_EMAIL_MODAL = 'communicationCloseDeleteEmailModal'

export const COMMUNICATION_OPEN_ARCHIVE_SMS_MODAL = 'communicationOpenArchiveSMSModal'
export const COMMUNICATION_CLOSE_ARCHIVE_SMS_MODAL = 'communicationCloseArchiveSMSModal'
export const COMMUNICATION_OPEN_DELETE_SMS_MODAL = 'communicationOpenDeleteSMSModal'
export const COMMUNICATION_CLOSE_DELETE_SMS_MODAL = 'communicationCloseDeleteSMSModal'
export const COMMUNICATION_OPEN_ADD_CATEGORIES_MODAL = 'communicationOpenAddCategoriesModal'
export const COMMUNICATION_CLOSE_ADD_CATEGORIES_MODAL = 'communicationCloseAddCategoriesModal'

export const COMMUNICATION_SET_BLOG_ENTRY = 'communicationSetBlogEntry'
export const COMMUNICATION_SET_EMAIL = 'communicationSetEmail'
export const COMMUNICATION_SET_EMAIL_DELIVERIES = 'communicationSetEmailDeliveries'
export const COMMUNICATION_SET_SMS = 'communicationSetSMS'
export const COMMUNICATION_SET_SMS_DELIVERIES = 'communicationSetSMSDeliveries'
export const COMMUNICATION_SET_CATEGORIES = 'communicationSetCategories'

export const COMMUNICATION_SET_COMMUNICATION_CATEGORY_MEMBERSHIP_GROUPS = 'communicationSetCommunicationCategoryMembershipGroups'
